import qs from 'qs';
import { axiosInstance } from './rest';

export function fetchCylinders(params) {
  const requestData = {
    params: {
      ...params,
    },
  };
  return axiosInstance.get(`/api/v2/mks/mechanicalCylinders`, requestData);
}

export function fetchKeys(params) {
  const requestData = {
    params: {
      ...params,
    },
  };
  return axiosInstance.get(`/api/v2/mks/mechanicalKeys`, requestData);
}

export function fetchMechanicalCylinderKeyRelations(params) {
  const requestData = {
    params: {
      ...params,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  };
  return axiosInstance.get(`/api/v2/mks/mechanicalCylinderKeyRelations`, requestData);
}

export function fetchMKSRequests(params) {
  const requestData = {
    params: {
      ...params,
      statuses: params.status || undefined,
      status: undefined,
    },
    paramsSerializer: (params) => qs.stringify(params),
  };
  return axiosInstance.get('/api/v2/mks/requests', requestData);
}

export function exportMKSRequests(params) {
  const requestData = {
    params,
    paramsSerializer: (params) => qs.stringify(params),
  };
  return axiosInstance.get('/api/v2/mks/requests/export', requestData);
}

export function fetchMKSRequestById(requestId) {
  return axiosInstance.get(`/api/v2/mks/requests/${requestId}`);
}

export function createMKSRequest(data) {
  return axiosInstance.post('/api/v2/mks/requests', data);
}

export function updateMKSRequest(requestId, data) {
  return axiosInstance.put(`/api/v2/mks/requests/${requestId}`, data);
}

export function deleteMKSRequest(requestId) {
  return axiosInstance.delete(`/api/v2/mks/requests/${requestId}`);
}

export function fetchCylinderById(cylinderId) {
  return axiosInstance.get(`/api/v2/mks/mechanicalCylinders/${cylinderId}`);
}

export function fetchKeyById(keyId) {
  return axiosInstance.get(`/api/v2/mks/mechanicalKeys/${keyId}`);
}